import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../../DependencyHelper";
import formStyles from "../../NewLineForms.module.scss";
import DropDown from "../../dropDown/DropDown";

const EmploymentDetailsAddLineForm = ({
  formName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  onChangeHandler,
  onBlurHandler,
}) => {
  const handleChange = event => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  return (
    <CustomContainer className={`${formStyles["main-container"]}`}>
      <Form.Row className={`${formStyles["main-row"]}`}>
        <>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormed106`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormed106-label`}
            >
              Gross monthly salary
            </Form.Label>
            <Form.Control
              type="text"
              name="grossMonthlySalary"
              value={fieldValues["grossMonthlySalary"]}
              placeholder="Add your gross monthly salary"
              required
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={fieldErrors["grossMonthlySalary"]}
              className={
                fieldErrors["grossMonthlySalary"] ? formStyles["invalid"] : ""
              }
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["grossMonthlySalary"]}
            </Form.Control.Feedback>
            {!fieldErrors["grossMonthlySalary"] && (
              <div className={formStyles["hint-text"]}>
                {"This is your total monthly salary before deduction"}
              </div>
            )}
          </Form.Group>
        </>
      </Form.Row>
    </CustomContainer>
  );
};

EmploymentDetailsAddLineForm.propTypes = {
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  onChangeHandler: PropTypes.func,
};

EmploymentDetailsAddLineForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
};

export default EmploymentDetailsAddLineForm;
